<p-table #validees [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="listeOpCol" [value]="listeOp" class="p-col-12">
    
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of listeOpCol" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ></p-sortIcon>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-values let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
            <span  *ngIf="col.field === 'matricule'">
              {{values[col.field]}}
            </span>

            <div *ngIf="col.field === 'superviser'" [class]="supervisionStatut(values['superviser'])">

            </div>
        </td>
        <td><p-button class="btn-info" [iconPos]="'right'" icon="pi pi-eye" (click)="setSupervision(values)" ></p-button></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td  style="text-align:center; height: 50px;background-color: #f9f7f5;" >Pas de donnée à afficher.</td>
      </tr>
    </ng-template>
</p-table>
